import { graphql, Link } from "gatsby"
import _ from "lodash"
import React from "react"
import Footer from "../../components/shared/footer"
import Layout from "../../components/shared/layout"
import SEO from "../../components/shared/seo"
import FixedHeaderSpacer from "../atoms/fixed-header-spacer"
import InternalRoutes from "../util/internal-routes"
import ListingArticles from "./article-listing/articles"
import ListingBreadcrumbs from "./article-listing/breadcrumbs"
import ListingHeader from "./article-listing/header"
import ListingPagination from "./article-listing/pagination"
import ExploreCategories from "./explore-categories"

const title = "All Articles"

/**
 * Template for generated Contentful all articles page
 * @param data - articles and categories
 * @param pageContext - pagination info
 */
const AllArticlesPage = ({
  pageContext: { currentPage, numPages },
  data: { articles, categories },
  location,
}) => {
  return (
    <Layout showBackground={true} contactLightbox={true} location={location}>
      <SEO title={title} />
      <FixedHeaderSpacer />
      <ListingBreadcrumbs>
        <Link to={InternalRoutes.Blog()}>Home</Link>
        <Link to={InternalRoutes.Blog({ slug: "all" })}>All Articles</Link>
      </ListingBreadcrumbs>
      <ListingHeader
        title={title}
        subtitle={`${articles.totalCount} Article${
          articles.totalCount > 1 ? `s` : ``
        }`}
      />
      <ListingArticles articles={articles.edges} />
      <ListingPagination
        currentPage={currentPage}
        totalPages={numPages}
        pagePrefix={InternalRoutes.Blog({ slug: "all" })}
      />
      <ExploreCategories
        categories={categories.distinct
          .map((category) => ({
            name: category,
            slug: _.kebabCase(category.toLowerCase()),
          }))
          .sort()
          .reverse()}
      />
      <Footer />
    </Layout>
  )
}

export default AllArticlesPage

export const allArticlesPageQuery = graphql`
  query ($limit: Int, $skip: Int) {
    articles: allContentfulBlogPost(
      limit: $limit
      skip: $skip
      sort: { fields: publishDate, order: DESC }
    ) {
      edges {
        node {
          ...ContentfulBlogPostFragment
        }
      }
      totalCount
    }
    categories: allContentfulBlogPostTagsJsonNode {
      distinct(field: category___name)
    }
  }
`
